//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordStudyChip from '@/components/innovation/WordStudyChip.vue'
export default {
  components: { WordStudyChip },
  data () {
    return {
      contest: null,
      words: [],
      teams: [],
      myTeam: null,
      showCreate: false,
      teamName: '梦想队',
      creating: false
    }
  },
  computed: {
    statusText () {
      const s = (this.contest && this.contest.status) || ''
      return ({ ongoing: '进行中', upcoming: '即将开始', ended: '已结束' })[s] || s
    }
  },
  created () { this.load() },
  methods: {
    load () {
      this.$ajax.get(this.$api.slContestDetail + '?id=' + this.$route.query.id).then(r => {
        this.contest = r.contest
        this.words = r.words || []
        this.teams = r.teams || []
        this.myTeam = r.my_team
      }).catch(e => {
        this.$toast && this.$toast(e.message || '加载失败')
      })
    },
    goTeam (id) {
      this.$router.push({ path: '/slTeam_display', query: { id } })
    },
    onCreateClose (action, done) {
      if (action === 'confirm') {
        this.doCreate().then(() => done()).catch(() => done(false))
      } else {
        done()
      }
    },
    doCreate () {
      const name = (this.teamName || '').trim()
      if (!name) {
        this.$toast && this.$toast('请填写队伍名称')
        return Promise.reject(new Error('empty'))
      }
      return this.$ajax.post(this.$api.slTeamCreate, {
        contest_id: this.$route.query.id,
        team_name: name
      }).then(r => {
        this.showCreate = false
        this.$router.push({ path: '/slTeam_display', query: { id: r.team_id } })
      }).catch(e => {
        this.$toast && this.$toast(e.message || '需开通词书才能创建队伍')
        return Promise.reject(e)
      })
    },
    join (id) {
      this.$ajax.post(this.$api.slTeamJoin, { team_id: id }).then(r => {
        this.$router.push({ path: '/slTeam_display', query: { id: r.team_id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '加入失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/contest-detail.vue